import React, { ReactNode } from "react";
import BaseListView from "./BaseListView";
import PortalRoot from "../portal/PortalRoot";
import { OverlayOpacity } from "../portal/types";
import { BackgroundColorType } from "./types";

export type BaseListPortalViewProps = {
    header?: ReactNode;
    footer?: ReactNode;
    onBack: () => void;
    baseZIndex?: number;
    children: ReactNode;
    sheetClassName?: string;
    backgroundColor?: BackgroundColorType;
    overlayOpacity?: OverlayOpacity;
};

const BaseListPortalView: React.FC<BaseListPortalViewProps> = ({
    header,
    footer,
    onBack,
    baseZIndex,
    children,
    sheetClassName,
    backgroundColor,
    overlayOpacity,
}) => {
    return (
        <PortalRoot overlayOpacity={overlayOpacity} baseZIndex={baseZIndex}>
            <BaseListView
                onClose={onBack}
                baseZIndex={baseZIndex}
                headerContent={header}
                footerContent={footer}
                sheetClassName={sheetClassName}
                backgroundColor={backgroundColor}
            >
                {children}
            </BaseListView>
        </PortalRoot>
    );
};

export default BaseListPortalView;
